export const setPartenaire = (partenaireData) => ({
	type: 'SET_PARTENAIRE',
	data: partenaireData
});


// WEBPACK FOOTER //
// ./src/actions/partenaire.js